module.exports = __webpack_public_path__ + "img/wx_gzh.93224b68.png";